import { render, staticRenderFns } from "./cmy-page.vue?vue&type=template&id=e14620c2&scoped=true&"
import script from "./cmy-page.vue?vue&type=script&lang=js&"
export * from "./cmy-page.vue?vue&type=script&lang=js&"
import style0 from "./cmy-page.vue?vue&type=style&index=0&id=e14620c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14620c2",
  null
  
)

export default component.exports